// extracted by mini-css-extract-plugin
module.exports = {"container":"FpCheck_container__2Q3QM","checkmark":"FpCheck_checkmark__2a9Ot"};